import { LoadingLarge } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';

const styles = {
  container: {
    display: 'flex',
    height: '100%',
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

class StaticLoading extends Component {
  render() {
    return (
      <div className={this.props.classes.container}>
        <LoadingLarge />
      </div>
    );
  }
}

StaticLoading.propTypes = {
  classes: PropTypes.object,
};

export default injectSheet(styles)(StaticLoading);
